import { IReport } from '../../state/types';
import { makeFetchReport } from './_shared/fetchMakers';
import { normalizeAndTranslateReport } from './_shared/normalizers';
import { makeRecognizedNumbersUrl } from './_shared/urlMakers';

export const fetchRecognizedNumbersSection = makeFetchReport<IReport>(
    makeRecognizedNumbersUrl,
    normalizeAndTranslateReport('containerNumbersParams')
);
